// extracted by mini-css-extract-plugin
export default {"container":"common_container__ZAM-V","desc":"common_desc__wbi3i"};